export function formatNumber(value: number, numberLocale?: string) {
  return value.toLocaleString(numberLocale);
}
